import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { SingleNotificationState } from '../../state/states/single-notification.state';
import { ReadNotificationInput } from '../../../shared/data/inputs/read-notification.input';
import { DeleteNotificationInput } from '../../../shared/data/inputs/delete-notification.input';
import { Router } from '@angular/router';

@Component({
  selector: 'anms-mention',
  templateUrl: './mention.component.html',
  styleUrls: ['./mention.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MentionComponent implements OnInit {
  @Input() notiState: SingleNotificationState;

  @Output() markedAsReadNotificationEvent = new EventEmitter<
    ReadNotificationInput
  >();
  @Output() deleteNotificationEvent = new EventEmitter<
    DeleteNotificationInput
  >();

  constructor(private router: Router) {}

  ngOnInit(): void {}

  markAsRead(): void {
    const input: ReadNotificationInput = {
      notificationID: this.notiState?.notification?.ID
    };

    this.markedAsReadNotificationEvent.emit(input);
  }

  deleteNotification(): void {
    const input: DeleteNotificationInput = {
      notificationID: this.notiState?.notification?.ID
    };

    this.deleteNotificationEvent.emit(input);
  }

  openPost() {
    if (this.notiState?.notification?.status === 'UNREAD') {
      this.markAsRead();
    }
    this.router.navigate([
      this.notiState?.notification?.users[0]?.handle,
      'post',
      this.notiState?.notification?.resourceID
    ]);
  }
}
